<template>
  <div v-if="providers">
    <div class="wrapper">
      <div class="calendarFrame">
        <h2>Select Date</h2>
        <simpleCalendar
          :startDate="dt"
          class="pt-3"
          buttonClass="btn btn-outline-light h-100"
          @monthChanged="monthChanged"
          :isSelectable="isSelectable"
          @daySelected="daySelected"
        />
      </div>

      <div style="border-left:1px solid #efefef"></div>

      <div v-if="providers.length == 0" class="mt-5 pt-6">
        <div style="text-align:center" class="m-5">
          <div class="text-muted h2">
            <i class="fad fa-calendar-check"></i><br />
            No Appoinments available. Change the selected procedures or the
            date.
          </div>
        </div>
      </div>

      <div v-if="providers.length > 0"  style="overflow-x:auto">
          <h2>Select Time</h2>

          <div>
            <div class="providerAppt snaps-inline">
              <div
                v-for="(provider,
                index) in getProvidersSchedulesForSelectedDate"
                v-bind:key="index"
 
                style="padding-top:18px"
              >
                <ProviderAvailAppt
                  :provider="provider"
                  @timeSelected="timeSelected"
                  @timeRemoved="timeRemoved"
                  :date="dt"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ProviderAvailAppt from "./ProviderAvailAppt.vue";

export default {
  components: { ProviderAvailAppt },
  props: { selectedProcedures: null },
  data() {
    return {
      days: null,
      dt: null,
      providers: null,
      scheduledProviders: [],
    };
  },
  watch: {
    scheduledProviders: {
      handler(newScheduledProviders, oldVal) {
        this.$emit("apptsUpdated", newScheduledProviders);
      },
      deep: true,
    },
    dt: {
      handler(newVal) {
        this.scheduledProviders = [];
      },
    },
    selectedProcedures: {
      immediate: true,
      deep: true,
      handler(newProcedures, oldVal) {
        this.bind();
      },
    },
  },
  computed: {
    getProvidersSchedulesForSelectedDate() {
      var providers = [];

      if (this.providers) {
        var providerCopy = JSON.parse(JSON.stringify(this.providers));

        providerCopy.forEach((provider) => {
          

          console.log(provider.schedule);

          var providerSchedules = provider.schedule[this.dt.getDate() - 1];
          
          if (providerSchedules.length > 0) {
            provider.schedule = providerSchedules;
            providers.push(provider);
          }
        });
      }

      return providers;
    },
  },
  created() {},

  methods: {
    timeRemoved(providerId) {
      // remove provider from scheduledProviders
      this.scheduledProviders = this.scheduledProviders.filter(
        (s) => s.provider.providerId != providerId
      );
    },
    timeSelected(t) {
      var provider = this.scheduledProviders.find(
        (p) => p.provider.providerId == t.provider.providerId
      );

      if (provider) {
        // have a provider change his start time and end time
        provider.startDate = t.timeFrame.startDate;
        provider.endDate = t.timeFrame.endDate;
      } else {
        this.scheduledProviders.push({
          provider: t.provider,
          startDate: t.timeFrame.startDate,
          endDate: t.timeFrame.endDate,
          procedures: t.timeFrame.procedures,
        });
      }

      console.log(this.scheduledProviders);
    },
    daySelected(d) {
      this.dt = d;
    },
    isSelectable(d) {

      console.log(d.getMonth())
   
      
      return this.days.find((f) => f.day == d.getDate() && f.month == d.getMonth() + 1 );
    },
    monthChanged(d) {
      this.dt = d;
      this.bind();
    },
    async bind() {

      let r = await this.$client.post("/api/appt/recommendAppt", {
        procedures: this.selectedProcedures,
        date: this.dt,
      });

      this.providers = r.data.value.providers;
      this.days = r.data.value.monthDays;
      let fd = r.data.value.firstDate;
      if (fd) this.dt = new Date(fd);
      
    },
  },
};
</script>

<style scoped>
.wrapper {
  display: grid;
  grid-template-columns: 275px 1px auto;

  column-gap: 55px;
}

.providerOverflow {
  overflow-x: scroll;
  overscroll-behavior: contain;
}

.providerAppt {
  display: grid;
  grid-auto-flow: column;

  padding-bottom: 25px;
}

.snaps-inline {
  scroll-snap-type: inline mandatory;
}

.snaps-inline > div {
  scroll-snap-align: start;
}

.providerAppt > div {
  width: 300px;
}

.wrapper > div {
}
.noDate {
  opacity: 0.1;
}
.hasDates {
  background-color: #ccffdd;
  border-radius: 30px;
  margin: 1px;
}

.calendarFrame {
  width: 290px;
}
</style>
